export default __webpack_public_path__ + "static/media/banner_w640.1fc4c57b.jpeg";